import React, { useEffect } from 'react'
import { AppRouteURI, AppRoutingRoles } from 'router/RoleBasedAccess'
import App from '../../components/app/App'
import UsersContainer from './UsersContainer'
import userActions from './actions'
import { TABS } from './constants'

export default () => {
    const { isProtected, checkRoles } = {
        ...AppRoutingRoles[AppRouteURI.MEMBERS],
    }
    const { setTab } = userActions()

    useEffect(() => {
        setTab(TABS.MEMBER_TAB)
    })
    return (
        <App isProtected={isProtected} checkRoles={checkRoles}>
            <UsersContainer />
        </App>
    )
}
